module.exports = __webpack_public_path__ + "static/media/oioi-placeholder.d3b26ef6.svg";